import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { TableDataModel } from 'src/app/shared/models/CommandCenterUI/TableDataModel.model';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';

@Component({
	selector: 'app-table-data-model-setup',
	templateUrl: './table-data-model-setup.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class TableDataModelSetupComponent implements OnInit {
	@Input() tableModel: TableDataModel;
	@Output() tableModelChange = new EventEmitter<TableDataModel>();

	filterTypeList: GenericLabelValue[] = [
		{
			label: 'Text',
			value: 'text',
		},
		{
			label: 'Number',
			value: 'numeric',
		},
		{
			label: 'Select Box',
			value: 'select',
		},
	];

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {}

	async save() {
		this.app.loading(true);
		this.tableModel.sk = `MODEL_${this.tableModel.name}`;
		const resp = await this.focuslink.adminCommandCenterTableDataModelSave(this.tableModel);
		this.tableModel = new TableDataModel(resp);
		this.tableModelChange.emit(this.tableModel);
		this.app.loading(false);
	}
}
